<template>
  <div class="wrapper-buttons-copy">
    <a v-show="!statusButton && !disabled" class="button-copy"
    @click="copyToClipboard();
      track(`historico_${this.advertiser.code}`, 'clicou_copiar');">
      <span class="text-copy">Copiar código</span>
    </a>
    <div class="button-copied" v-show="statusButton && !disabled">
      <img src="@/assets/icons/green_check.svg"
      alt="Sucesso ao copiar codigo" class="button-copied-check">
      <span class="text-copied">Código copiado</span>
    </div>
    <a class="button-expired disabled" v-show="disabled">
      <span class="text-expired">Codigo Expirado</span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'CopyButton',
  data() {
    return { statusButton: false };
  },
  props: {
    copyValue: String,
    disabled: Boolean,
  },
  methods: {
    copyToClipboard() {
      const dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = this.copyValue;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      this.statusButton = true;
      setTimeout(() => {
        this.statusButton = false;
      }, 5000);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper-buttons-copy{
  width: 145px;
  .button-copy{
    cursor: pointer;
    .text-copy{
      color: $denim;
      font-family: $font-1;
      font-size: 14px;
      line-height: 35px;
      font-weight: 100;
      @media (max-width: 768px) {
        font-size: 12px;
        line-height: 30px;
      }
    }
    &:hover{
      color: $denim;
    }
    @media (max-width: 768px) {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $denim;
      border-radius: 3px;
      width: 90%;
    }
  }

  .button-copied{
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid $jade;
    border-radius: 3px;
    .text-copied{
      color: $jade;
      font-family: $font-1;
      font-size: 14px;
      line-height: 35px;
      font-weight: 100;
      @media (max-width: 768px) {
        font-size: 12px;
        line-height: 30px;
      }
    }
    .button-copied-check{
      padding: 0 5px;
    }
    @media (max-width: 768px) {
      width: 80%;
    }
  }

  .button-expired{
    .text-expired{
      color: $silver;
      font-family: $font-1;
      font-size: 14px;
      line-height: 35px;
      font-weight: 100;
      @media (max-width: 768px) {
        font-size: 12px;
        line-height: 30px;
      }
    }
    @media (max-width: 768px) {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      border: 1px solid $silver;
      width: 80%;
    }
  }
}
</style>
